import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { notification } from 'antd';

import { MainLayout } from 'components/Layout/MainLayout';
import { useAppDispatch, useAppSelector } from 'store';
import {
  loadInvestmentProjectsItem,
  saveInvestmentProjectsItem,
  saveInvestmentProjectsItemDraft,
} from 'store/slices/investmentProjects/actions';
import { InvestmentProjectsItem } from 'store/slices/investmentProjects/interfaces';
import { StatusesEnum } from 'constants/status';
import { DeepPartial } from 'types/utils';

import { InvestmentForm } from './components/InvestmentForm';
import { mapValuesToForm } from './components/InvestmentForm/formUtils';

export const Edit = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const { id = '' } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { item } = useAppSelector(state => state.investmentProjects);
  const isCorrectItem = item?.id === Number(id);

  React.useEffect(() => {
    dispatch(loadInvestmentProjectsItem(id));
  }, [id]);

  const onSubmit = (values: InvestmentProjectsItem) => {
    setIsLoading(true);
    const newItem = { ...values, id: item?.id };
    dispatch(saveInvestmentProjectsItem(newItem))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Инвестиционный проект успешно обновлен',
        });
        navigate('/investmentProjects');
      })
      .catch(() => setIsLoading(false));
  };

  const onSaveAsDraft = (values: DeepPartial<InvestmentProjectsItem>) => {
    setIsLoading(true);
    dispatch(saveInvestmentProjectsItemDraft({ ...values, id: item?.id }))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Инвестиционный проект успешно создан',
        });
        navigate('/investmentProjects');
      })
      .catch(() => setIsLoading(false));
  };

  return (
    <MainLayout pageTitle='Редактирование'>
      {isCorrectItem && (
        <InvestmentForm
          onSubmit={onSubmit}
          isDraft={item.status === StatusesEnum.DRAFT}
          isLoading={isLoading}
          defaultValues={mapValuesToForm(item)}
          onSaveAsDraft={onSaveAsDraft}
        />
      )}
    </MainLayout>
  );
};
